import UTIL from "mroads-js-utils";

const height = window.innerHeight;
const width = window.innerWidth;

function createViewPortConfig(baseDeviceWidth = 1440, baseDeviceHeight = 900) {
  let screenWidth = width;
  let screenHeight = height;
  if (height > width) {
    screenWidth = height;
    screenHeight = width;
  }
  return {
    vw: UTIL.round(screenWidth / baseDeviceWidth),
    vh: UTIL.round(screenHeight / baseDeviceHeight),
  };
}

export default createViewPortConfig(1440, 900);
